

const Action={
    name:"Action",
    type:"object",
    props:[
        {
            name:"ref",
            type:"string",
            description:"Used to identify the action",
        },
        {
            name:"type",
            type:`"button"|"input"|"select"`,
            description:`Default: "button"`,
        },
        {name:"label",type:"string"},
        {
            name:"options",
            type:"string[]",
            description:"The options of a select action",
        },
        {
            name:"placeholder",
            type:"string",
            description:"The placeholder of an input action",
        },
        {
            name:"color",
            type:"string",
            description:"The label color, Android only",
        },
        {
            name:"icon",
            type:"string",
            description:`
                The action icon
                @Supports a path or a base64 string.
                @Android <7 only.
            `,
        },
    ],
}

export default {
    id:"Notifier",
    name:"vritra-plugin-notifier",
    description:`
        a cordova plugin for toast messages and local notifications
        @defines a global <b>Notifier</b> object
    `,
    methods:[
        {
            name:"toast",
            type:"(props:object):void",
            props:[{
                name:"props",
                type:"object",
                props:[
                    {name:"text",type:"string"},
                    {
                        name:"lasting",
                        type:`"short"|"long"`,
                        description:"Specifies for how long the toast will last before disappearing",
                    },
                    {
                        name:"style",type:"object",
                        props:[
                            {name:"color",type:"string"},
                            {name:"backgroundColor",type:"string"},
                            {
                                name:"verticalAlign",
                                type:`"top"|"middle"|"bottom"`,
                            },
                            {
                                name:"opacity",type:"number",
                                defaultValue:0.9,
                            },
                            {
                                name:"borderRadius",
                                type:"number",
                                defaultValue:60,
                            },
                        ],
                        notice:`
                            If a style object is provided, then a TextView/UITextView is used on android/iOS
                            otherwise a native toast message is shown
                        `,
                    },
                ],
            }],
        },
        {
            name:"notify",
            type:"(notification:Object):void",
            props:[{
                name:"notification",type:"object",
                props:[
                    {
                        name:"id",
                        type:"number",
                        description:"Used to dismiss the notification programmatically",
                    },
                    ...["title","subtext","body"].map(name=>({name,type:"string"})),
                    {
                        name:"fullbody",
                        type:"boolean",
                        description:"show all body text (respecting system characters limits), default to false",
                    },
                    {
                        name:"icon",
                        type:"string",
                        description:`
                            Edits notification icon
                            @Supports a path or a base64 string
                            @android only
                        `,
                    },
                    {
                        name:"largeIcon",
                        type:`"appIcon"|string`,
                        description:`
                            An icon that is shown on the middle right side of the notification. 
                            @Used to Attach an image to the notification. 
                            @Supports a base64 string or path to image file.
                            @The value "appIcon" will use the app icon.
                        `,
                    },
                    {
                        name:"actions",
                        type:"Action[]",
                        description:`
                            Notification actions.
                            @Allows up to 3 actions. 
                        `,
                        props:[Action],
                    },
                    {
                        name:"once",
                        type:"boolean",
                        description:"if true, Dismiss notification on user interaction, default: true",
                    },
                    {
                        name:"sticky",
                        type:"boolean",
                        description:`
                            Prevents the user from dismissing the notification. 
                            @Android only.
                            @Default: false. 
                        `,
                    },
                    {
                        name:"color",
                        type:"string",
                        description:`
                            Notification main text color.
                            @Supports an hex color code.
                            @Android only.
                        `,
                    },
                    {
                        name:"onAction",
                        type:"(action:Object):void",
                        props:[{
                            name:"action",type:"object",
                            props:[
                                ...["ref","type"].map(name=>({name,type:"string"})),
                                {
                                    name:"input",
                                    type:"string",
                                    description:`The user input for actions with type "input"`,
                                },
                            ],
                        }],
                    },
                ],
            }],
        },
        {
            name:"dismiss",
            type:"(notificationId:number):void",
            description:"Dismissed notification with the specified id",
        },
    ],
} 
